(function () {
  var root = document.querySelector("[data-cadian-popup]");
  if (!root) return;

  var launcher = document.querySelector("[data-cp-launcher]");
  var dialog = root.querySelector('[role="dialog"]');
  var previousFocus = null;
  var inerted = [];

  var trigger = root.dataset.trigger || "exit_intent";
  var delay = Number(root.dataset.delayMs || 30000);
  var scrollPercent = Number(root.dataset.scrollPercent || 50);
  var minDwell = Number(root.dataset.minDwellMs || 15000);
  var lockScroll = root.dataset.lockScroll === "true";
  var code = root.dataset.code || "SLEEPBETTER";

  var claimedKey = "cadian_popup_claimed";
  var codeKey = "cadian_popup_code";
  var dismissedKey = "cadian_popup_dismissed";

  var loadedAt = Date.now();
  var opened = false;
  var lockedScrollY = 0;
  var isLocked = false;

  var scrim = root.querySelector("[data-cp-scrim]");
  var steps = {
    choice: root.querySelector('[data-cp-step="choice"]'),
    email: root.querySelector('[data-cp-step="email"]'),
    offer: root.querySelector('[data-cp-step="offer"]'),
  };
  var emailInput = root.querySelector("[data-cp-email]");
  var errorEl = root.querySelector("[data-cp-error]");
  var selected = { label: "", tag: "" };

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function dismissedRecently() {
    var raw = storageGet(dismissedKey);
    if (!raw) return false;
    return Date.now() - Number(raw) < 14 * 24 * 60 * 60 * 1000;
  }

  function showLauncher() {
    if (launcher) launcher.hidden = false;
  }

  function hideLauncher() {
    if (launcher) launcher.hidden = true;
  }

  // Scroll locking is opt-in. In the Instagram and Facebook in-app browsers a
  // lock that fails to release leaves the page frozen, which is far worse than
  // letting the background scroll behind the scrim. Whenever it is on, every
  // path out of the popup unlocks, and a watchdog catches anything that slips.
  function lock() {
    if (!lockScroll || isLocked) return;
    lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = "fixed";
    document.body.style.top = -lockedScrollY + "px";
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    isLocked = true;
  }

  function unlock() {
    if (!isLocked) return;
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    window.scrollTo(0, lockedScrollY);
    isLocked = false;
  }

  window.addEventListener("pagehide", unlock);
  window.addEventListener("pageshow", function () { if (root.hidden) unlock(); });
  window.setInterval(function () { if (root.hidden && isLocked) unlock(); }, 1000);

  function show() {
    if (!root.hidden) return;
    opened = true;
    previousFocus = document.activeElement;
    root.hidden = false;
    hideLauncher();
    lock();
    var branch = root;
    while (branch.parentElement && branch !== document.body) {
      Array.from(branch.parentElement.children).forEach(function (sibling) {
        if (sibling !== branch && !sibling.inert) {
          sibling.inert = true;
          inerted.push(sibling);
        }
      });
      branch = branch.parentElement;
    }
    var focusTarget = root.querySelector('[data-cp-close]') || dialog;
    if (focusTarget) focusTarget.focus();
  }

  function hide(persist) {
    root.hidden = true;
    unlock();
    inerted.forEach(function (element) { element.inert = false; });
    inerted = [];
    if (persist) storageSet(dismissedKey, String(Date.now()));
    showLauncher();
    if (previousFocus && previousFocus.isConnected && previousFocus !== launcher) previousFocus.focus();
  }

  function showStep(name) {
    Object.keys(steps).forEach(function (key) {
      if (steps[key]) steps[key].hidden = key !== name;
    });
    var heading = steps[name] && steps[name].querySelector('h2');
    if (heading && dialog) {
      heading.id = 'cadian-popup-title-' + name;
      dialog.setAttribute('aria-labelledby', heading.id);
    }
  }

  function applyDiscount() {
    storageSet(codeKey, code);
    return fetch("/cart.js", { headers: { Accept: "application/json" }, credentials: "same-origin" })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = [];
        (cart.discount_codes || []).forEach(function (item) {
          if (item && item.code && codes.indexOf(item.code) === -1) codes.push(item.code);
        });
        if (codes.indexOf(code) === -1) codes.push(code);
        return fetch("/cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ discount: codes.join(",") }),
        });
      })
      .catch(function () {});
  }

  root.querySelectorAll("[data-cp-choice]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      selected.label = btn.getAttribute("data-cp-label") || btn.textContent.trim();
      selected.tag = btn.getAttribute("data-cp-tag") || "";
      var tagField = root.querySelector("[data-cp-tags]");
      if (tagField) {
        tagField.value = ["newsletter", "popup-10", "sleepbetter", selected.tag]
          .filter(Boolean)
          .join(", ");
      }
      showStep("email");
      if (emailInput) emailInput.focus();
    });
  });

  // Shopify's native customer form owns validation, submission and any
  // spam challenge. Only its server-confirmed result unlocks this offer.
  var signupSucceeded = root.querySelector("[data-cp-success]");
  var signupFailed = root.querySelector("[data-cp-server-errors]");

  root.querySelectorAll("[data-cp-close]").forEach(function (btn) {
    btn.addEventListener("click", function () { hide(true); });
  });

  if (scrim) {
    scrim.addEventListener("click", function (event) {
      if (event.target === scrim) hide(true);
    });
  }

  document.addEventListener("keydown", function (event) {
    if (root.hidden) return;
    if (event.key === "Escape") { hide(true); return; }
    if (event.key !== "Tab") return;
    var focusable = Array.from(root.querySelectorAll('button, a[href], input:not([type="hidden"]), [tabindex="0"]')).filter(function (el) {
      return !el.disabled && el.getClientRects().length > 0;
    });
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === dialog)) {
      event.preventDefault(); if (last) last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault(); if (first) first.focus();
    }
  });

  if (launcher) {
    launcher.addEventListener('click', function () {
      previousFocus = launcher;
      showStep('choice');
      show();
    });
  }

  if (signupSucceeded) {
    storageSet(claimedKey, "true");
    showStep("offer");
    show();
    applyDiscount();
    return;
  }

  if (signupFailed) {
    showStep("email");
    show();
    if (errorEl) errorEl.hidden = false;
    if (emailInput) emailInput.focus();
    return;
  }

  if (storageGet(claimedKey)) return;

  if (dismissedRecently()) {
    showLauncher();
    return;
  }

  // Manual: the offer button is the only way in. Used on product pages so the
  // buying flow is never interrupted.
  if (trigger === "manual") {
    showLauncher();
    return;
  }

  function dwellMet() {
    return Date.now() - loadedAt >= minDwell;
  }

  function openOnce() {
    if (opened || !root.hidden) return;
    show();
  }

  function scrolledPast() {
    var doc = document.documentElement;
    var scrollable = doc.scrollHeight - window.innerHeight;
    if (scrollable <= 0) return false;
    var pct = ((window.pageYOffset || doc.scrollTop || 0) / scrollable) * 100;
    return pct >= scrollPercent;
  }

  function bindScrollTrigger() {
    var onScroll = function () {
      if (!dwellMet() || !scrolledPast()) return;
      window.removeEventListener("scroll", onScroll);
      openOnce();
    };
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  var coarsePointer = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;

  if (trigger === "timer") {
    window.setTimeout(openOnce, Math.max(0, delay));
  } else if (trigger === "scroll") {
    bindScrollTrigger();
  } else {
    // exit_intent: real exit intent needs a mouse. Touch devices fall back to
    // scroll depth, which is the closest honest proxy.
    if (coarsePointer) {
      bindScrollTrigger();
    } else {
      document.addEventListener("mouseout", function (event) {
        if (event.relatedTarget || event.toElement) return;
        if (event.clientY > 0) return;
        if (!dwellMet()) return;
        openOnce();
      });
    }
  }
})();
